import { useSeo, HOME_SEO } from "@/hooks/useSeo";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import WhyAI from "@/pages/home/components/WhyAI";
import Services from "@/pages/home/components/Services";
import RoiImpact from "@/pages/home/components/RoiImpact";
import Process from "@/pages/home/components/Process";
import LeadForm from "@/pages/home/components/LeadForm";
import FAQ from "@/pages/home/components/FAQ";
import CTA from "@/pages/home/components/CTA";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  useSeo(HOME_SEO);
  return (
    <main className="relative bg-background-50 text-foreground-900 font-body">
      <Navbar />
      <Hero />
      <WhyAI />
      <Services />
      <RoiImpact />
      <Process />
      <LeadForm />
      <FAQ />
      <CTA />
      <Footer />
    </main>
  );
}